import React from 'react';
import { ScoreProvider } from './components/ScoreContext';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { Diagnostic } from './components/Diagnostic';
import { HeroV2 } from './components/v2/HeroV2';
import { BusinessPayoffV2 } from './components/v2/BusinessPayoffV2';
import { Gap } from './components/v2/Gap';
import { QuickCheck } from './components/v2/QuickCheck';
import { Solution } from './components/v2/Solution';
import { PrototypeProof } from './components/v2/PrototypeProof';
import { FitInvestment } from './components/v2/FitInvestment';
import { AuthorLeverage } from './components/v2/AuthorLeverage';
import { SalesEnablement } from './components/v2/SalesEnablement';
import { DoneForYou } from './components/v2/DoneForYou';
import { ScoreAuditBuild } from './components/v2/ScoreAuditBuild';
import { FaqFinalCta } from './components/v2/FaqFinalCta';
export function AppV2() {
  return <ScoreProvider data-id="element-16" data-mp="7x51n1s4osv6">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass selection:text-white" data-id="element-17" data-mp="7vk7hd9q7bxu">
        <Nav data-id="element-18" data-mp="ctvgxmw3zkfj" />
        <main data-id="element-19" data-mp="cxjc0qh7cewd">
          <HeroV2 data-id="element-20" data-mp="cx9gyohavhjt" />
          <BusinessPayoffV2 data-id="element-21" data-mp="htzylg8r6l7c" />
          <Gap data-id="element-22" data-mp="hvukoxvrgjd0" />
          <QuickCheck questionId="q2.intent.handRaiserContext" checkLabel="Quick Check" confirmationText="Saved. This is part of your Reader-to-Revenue Score." data-id="element-23" data-mp="hv2rtutjszqf" />
          <Solution data-id="element-24" data-mp="3lc1d288q6u6h" />
          <PrototypeProof data-id="element-25" data-mp="3lcktfkiq9aie" />
          <FitInvestment data-id="element-26" data-mp="3l95fil0si7ik" />
          <AuthorLeverage data-id="element-27" data-mp="3qa369lzv89vo" />
          <SalesEnablement data-id="element-28" data-mp="3qbea1ltb9hms" />
          <DoneForYou data-id="element-29" data-mp="3qame29vsxhvz" />
          <ScoreAuditBuild data-id="element-30" data-mp="3q804k4pcosb4" />
          <FaqFinalCta data-id="element-31" data-mp="3v8w8ujdm6gh2" />
        </main>
        <Footer data-id="element-32" data-mp="3v7v04lk2m62i" />
        <StickyWidget data-id="element-33" data-mp="3v7cuiybiqfhx" />
        <Diagnostic data-id="element-34" data-mp="3ui4qmglohr4" />
      </div>
    </ScoreProvider>;
}